import ScrollTrigger from "gsap/ScrollTrigger";
import gsap from "gsap";

const duration = 0.45;
const easeOut = "power2.out";

export default function Header() {
  Alpine.data("header", () => ({
    hide: false,
    showbackdrop: false,
    overlay: null,
    menuTl: null,
    isMobileMenuOpen: false,
    init() {
      this.overlay = document.querySelector("[data-header-mobilemenu]");

      this.createMenuTimeline();

      gsap.fromTo(
        this.$refs.backdrop,
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            start: "top top",
            end: () => this.$el.clientHeight * 2,
            scrub: true,
          },
        },
      );

      const mm = gsap.matchMedia();
      mm.add("(min-width: 1024px)", () => {
        gsap.fromTo(
          this.$refs.logo,
          {
            scale: 1.3,
          },
          {
            scale: 1,
            ease: "power2.out",
            scrollTrigger: {
              start: "top top",
              end: () => this.$el.clientHeight * 2,
              scrub: true,
            },
          },
        );

        return () => {
          gsap.set(this.$refs.logo, { scale: 1 });
        };
      });

      setTimeout(() => {
        ScrollTrigger.create({
          start: () => this.$el.clientHeight * 2.5,
          end: 999999,
          onUpdate: (self) => {
            this.hide = self.isActive && self.direction !== -1;
            this.showbackdrop = self.isActive;

            if (this.showbackdrop && self.progress !== 0) {
              this.$root.style.color = "white";
            } else {
              this.$root.style.color = "";
            }

            // gsap.to(this.$refs.backdrop, {
            //   opacity: this.showbackdrop ? 1 : 0,
            //   duration,
            //   delay: this.hide ? duration : 0,
            //   ease: easeOut,
            //   overwrite: true,
            // });

            gsap.to(this.$el, {
              yPercent: this.hide ? -100 : 0,
              duration,
              ease: easeOut,
            });
          },
        });
      }, 100);
    },
    createMenuTimeline() {
      this.menuTl = gsap
        .timeline({ paused: true })
        .fromTo(
          this.$refs.menuButton.children[0],
          {
            opacity: 1,
            yPercent: 0,
          },
          {
            opacity: 0,
            yPercent: -100,
            duration: 0.4,
            ease: "ease.out",
          },
        )
        .fromTo(
          this.$refs.menuButton.children[2],
          {
            opacity: 1,
            yPercent: 0,
          },
          {
            opacity: 0,
            yPercent: 100,
            duration: 0.4,
            ease: "ease.out",
          },
          "-=100%",
        )
        .fromTo(
          this.overlay,
          {
            display: "none",
            opacity: 0,
          },
          {
            display: "block",
            opacity: 1,
            duration: 0.4,
            ease: "ease.out",
          },
          "-=100%",
        );
    },
    toggleMenu() {
      console.log("toggle menu", this.menuTl, this.overlay);

      if (this.isMobileMenuOpen) {
        this.isMobileMenuOpen = false;
        this.menuTl.timeScale(1);
        this.menuTl.reverse();
      } else {
        this.isMobileMenuOpen = true;
        this.menuTl.timeScale(1);
        this.menuTl.play();
      }
    },
  }));
}
